angular.module('tradersyard').directive('inviteHandle', [
    '$rootScope',
    function ($root) {
        return {
            scope: true,
            link: function ($scope, $element, $attr) {
                $element.bind('click', function () {
                    $root.$broadcast('invite-form-open');
                });
            },
        };
    },
]);
